import type { DataGridCellRendererProps } from '@myosh/odin-components';
import { DataGridDataCell } from '@myosh/odin-components';
import type { Ref } from 'react';
import { forwardRef } from 'react';
import type { RecordLinkEntity } from '../../../../@types/linked-records-field';
import { resolveFieldDisplayValue } from '../../../../utils/field-property-util';

function UserRecordLinkPropertyNameCell({ column, rowData }: DataGridCellRendererProps, ref: Ref<HTMLDivElement>) {
  const _column = column as RecordLinkEntity;

  return (
    <DataGridDataCell
      ref={ref}
      value={resolveFieldDisplayValue(rowData[_column.entityPropertyName])}
      width={column.width}
    />
  );
}

export default forwardRef(UserRecordLinkPropertyNameCell);
